export const runEntityBusinessModal = async($uibModal, business, save) => {
	return await $uibModal.open({
		component: "entity-business-modal",
		size: "smmd",
		backdrop: "static",
		resolve: {
			business: () => business,
			save: () => save
		}
	}).result;
};